import { Link, usePage } from "@inertiajs/react"

import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar"
import type { NavItem } from "@/types"

export function NavMain({
  items = [],
  children,
}: {
  items: NavItem[]
  children?: React.ReactNode
}) {
  const page = usePage()
  const url = page.url

  const matchesHref = (href: string) =>
    url === href || url.startsWith(href + "/") || url.startsWith(href + "?")

  const activeHref = items
    .map((i) => i.href)
    .filter((href) => matchesHref(href))
    .sort((a, b) => b.length - a.length)[0]
  return (
    <SidebarGroup className="px-2 py-0">
      <SidebarGroupLabel>Platform</SidebarGroupLabel>
      <SidebarMenu>
        {children}
        {items.map((item) => (
          <SidebarMenuItem key={item.title}>
            <SidebarMenuButton
              asChild
              isActive={item.href === activeHref}
              tooltip={{ children: item.title }}
              className={
                item.indent
                  ? "pl-6 group-data-[collapsible=icon]:pl-2!"
                  : undefined
              }
            >
              <Link href={item.href} prefetch={item.prefetch ?? true}>
                {item.icon && <item.icon />}
                <span>{item.title}</span>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
        ))}
      </SidebarMenu>
    </SidebarGroup>
  )
}
